<template>
  <div>
    <h1>Configurador de Saída de Manutenção</h1>
    <router-link :to="'/checklist/vehicleRevisionExit/list'">
      <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
    </router-link>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <RevisionExitConfigurationCrud
      :model.sync="config"
      :submitted.sync="submitted"
    ></RevisionExitConfigurationCrud>
    <b-button @click="handleSave" :disabled="submitted">Salvar</b-button>
  </div>
</template>

<script>
export default {
  name: "RevisionExitConfiguration",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    RevisionExitConfigurationCrud: () =>
      import(
        "@/components_rms/vehicle/Revision/RevisionConfigurations/RevisionExitConfigurationCrud.vue"
      ),
  },
  data() {
    return {
      config: [],
      alert: {
        error: "",
        success: "",
      },
      submitted: false,
    };
  },
  methods: {
    async handleSave() {
      this.submitted = true;
      this.$apiChecklist
        .post("/exitConfiguration/save/", this.config)
        .then((response) => {
          this.config = response.data;
          this.alert.success = "Configuração salva com sucesso!";
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch((error) => {
          console.error(error);
          this.alert.error = "Erro ao salvar configuração";
          this.$refs.fadeAlertDanger.show();
          this.submitted = false;
        });
    },
    prevPage() {
      this.tableCurrentPage--;
      this.$refs.table.refresh();
    },
  },
  async mounted() {
    this.submitted = true;
    this.$apiChecklist
      .get("/exitConfiguration/get/")
      .then((response) => {
        this.config = response.data;
        this.submitted = false;
      })
      .catch((error) => {
        console.error(error);
        this.alert.error = "Erro ao carregar configuração";
        this.$refs.fadeAlertDanger.show();
        this.submitted = false;
      });
  },
};
</script>

<style scoped>
/* Your component styles go here */
</style>